module.exports = __webpack_public_path__ + "static/media/lucidus-ordo.67bf7990.jpg";